// extracted by mini-css-extract-plugin
export default {"attitude":"Monitor2_attitude__pihRT"};